export const s = {
  name: 'Aramızdaki En',
  pitch: 'Aramızdaki en geç kalan kim? Herkes gizlice oy verir, unvanı biri kapar',
  prefix: 'Aramızdaki en',
  suffix: 'kim?',
  /** Unvan biçimi: "en geç kalan". */
  title: (text: string) => `en ${text}`,
  settings: {
    readOnly: 'Ayarları oda sahibi seçer.',
    categories: 'Soru kategorileri',
    categoriesHint: '+18 kategoriler varsayılan olarak kapalıdır.',
    adultWarning: (names: string) => `${names} açık cinsel içerik içerir; yalnızca yetişkinler içindir.`,
    seconds: 'Oy süresi',
    sec: (n: number) => (n === 0 ? 'Süresiz' : `${n} sn`),
    secondsHint: (n: number) => (n === 0 ? 'Herkes oy verince sonuçlar açılır.' : 'Süre bitince oy vermeyenler beklenmez.'),
    rounds: 'Soru sayısı',
    unlimited: 'Sınırsız',
    roundsHint: (n: number) => (n === 0 ? 'Oda sahibi bitirene kadar sürer.' : `${n} sorudan sonra oyun biter.`),
    selfVote: 'Kendine oy',
    selfVoteHint: 'Açıkken oyuncular kendini de seçebilir.',
    anonymous: 'İsimsiz oylar',
    anonymousHint: (on: boolean) =>
      on ? 'Kimin kime oy verdiği kimseye gösterilmez, yalnızca sayılar açılır.' : 'Sonuçlarda kimin kime oy verdiği görünür.',
    predict: 'Tahmin modu',
    predictHint: 'Oy verirken kimin kazanacağını da tahmin et. Doğru tahmin 1 puan.',
    allowed: 'Serbest',
    notAllowed: 'Yasak',
    on: 'Açık',
    off: 'Kapalı',
    addPrompt: 'Soru ekle',
    addPromptHint: 'Eklediğin soru “Arkadaş soruları” kategorisine girer.',
    promptPlaceholder: 'ör. çok geç cevap veren',
    promptLabel: 'Sorunun boşluğu',
    save: 'Soruyu ekle',
    saving: 'Ekleniyor…',
    saved: (t: string) => `“Aramızdaki en ${t} kim?” eklendi.`,
    saveFailed: 'Soru eklenemedi. Bağlantını kontrol edip tekrar dene.',
  },
  play: {
    round: (n: number, total: number | null) => (total ? `Soru ${n}/${total}` : `Soru ${n}`),
    you: 'sen',
    tapToVote: (self: boolean) =>
      self
        ? 'Bir oyuncuya dokunarak oy ver; kendine de verebilirsin! Sonuçlar açılana kadar değiştirebilirsin.'
        : 'Bir oyuncuya dokunarak oy ver. Sonuçlar açılana kadar değiştirebilirsin.',
    tapToGuess: 'Sence kim kazanacak? Bir oyuncuya dokun.',
    modeVote: 'Oyum',
    modeGuess: 'Tahminim',
    noSelf: 'Kendine oy veremezsin',
    myVote: 'Oyun',
    myGuess: 'Tahminin',
    voted: 'oy verdi',
    timeLeft: (n: number) => `${n} saniye kaldı`,
    progress: (done: number, total: number) => `${done}/${total} kişi oy verdi`,
    waiting: 'Beklenenler',
    offline: 'bağlantı yok',
    skip: 'Soruyu atla',
    revealNow: 'Sonuçları şimdi aç',
    secondsLeft: 'sn',
    untimed: 'Herkes oy verince sonuçlar açılır.',
    anonymousNote: 'Oylar isimsiz. Kime verdiğini kimse görmeyecek.',
    openNote: 'Oylar açık. Sonuçlarda kimin kime verdiği görünecek.',
    // Açıklama
    winnerOne: 'Unvan sahibi',
    winnerLine: (title: string, votes: number) => `${title} · ${votes} oy`,
    winnerTie: 'Beraberlik, unvan paylaşıldı',
    noVotes: 'Kimse oy vermedi, bu unvan boşta kaldı.',
    votes: (n: number) => `${n} oy`,
    votedBy: 'Oy verenler',
    correctGuess: (names: string) => `Doğru tahmin edenler: ${names}`,
    nobodyGuessed: 'Kimse doğru tahmin etmedi.',
    next: 'Sıradaki soru',
    finish: 'Sonuçları gör',
    waitHost: 'Oda sahibi sıradaki soruya geçecek.',
  },
  side: {
    players: 'Oyuncular',
    titles: (n: number) => (n === 0 ? 'unvan yok' : `${n} unvan`),
    guessPts: (n: number) => `${n} tahmin`,
    history: 'Unvan geçmişi',
    settings: 'Oyun ayarları',
    settingsNote: 'Değişiklikler sıradaki sorudan itibaren geçerli.',
    historyEmpty: 'Henüz unvan dağıtılmadı. İlk sonuçlar açılınca burada görünecek.',
  },
  podium: {
    title: 'Oyun bitti',
    winner: (names: string) => `${names} kazandı!`,
    titlesLabel: 'Unvanlar',
    titleCount: (n: number) => `${n} unvan`,
    king: (n: number) => `${n} unvanla birinci`,
    nobody: 'Bu oyunda unvan dağıtılmadı',
    noTitles: 'Unvan yok',
    guess: (n: number) => `${n} doğru tahmin`,
    back: 'Lobiye dönülüyor…',
  },
  howto: {
    title: 'Nasıl oynanır',
    steps: [
      ['Soru gelir', 'Ekranda “Aramızdaki en … kim?” sorusu çıkar.'],
      ['Gizlice oy ver', 'Soruya en çok uyan oyuncuya dokun. Kimin oy verdiği görünür, kime verdiği görünmez.'],
      ['Sonuçlar açılır', 'Herkes oy verince ya da süre bitince oylar sayılır. En çok oyu alan unvanı kapar; beraberlikte unvan paylaşılır.'],
      ['Tahmin et', 'Tahmin modu açıksa kimin kazanacağını da seç. Doğru tahmin 1 puan.'],
    ] as [string, string][],
  },
};
